import { render, staticRenderFns } from "./TemperatureWidget.vue?vue&type=template&id=474b5373"
import script from "./TemperatureWidget.vue?vue&type=script&lang=js"
export * from "./TemperatureWidget.vue?vue&type=script&lang=js"
import style0 from "./TemperatureWidget.vue?vue&type=style&index=0&id=474b5373&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports